import api from "@/router/api";
import { jwtDecode } from "jwt-decode";
import { loginSTI } from "@/composables/autenticacaoSigaa";

export default {
  async getAllUsuarios(page, size) {
    const response = await api.get("/usuarios", {
      params: { page, size },
    });
    return response.data;
  },

  async pesquisarUsuarios(page, size, nome, unidadeNome, email, busca) {
    const params = { page, size };
    if (nome && nome.trim()) params.nome = nome.trim();
    if (email && email.trim()) params.email = email.trim();
    if (busca && busca.trim()) params.busca = busca.trim();
    if (unidadeNome && unidadeNome.trim())
      params.unidadeNome = unidadeNome.trim();

    const response = await api.get("/usuarios/pesquisar", { params });
    return response.data;
  },

  async pesquisarCoordenadores(page, size, nome, unidadeNome) {
    const params = { page, size };
    if (nome && nome.trim()) params.nome = nome.trim();
    if (unidadeNome && unidadeNome.trim())
      params.unidadeNome = unidadeNome.trim();

    const response = await api.get("/usuarios/pesquisar/coordenadores", {
      params,
    });
    return response.data;
  },

  async postUsuario(dadosUsuario) {
    const response = await api.post("/usuarios", dadosUsuario);
    return response.data;
  },

  async getAcoesUsuario() {
    const response = await api.get("/usuarios/acoes");
    return response.data;
  },

  async promoverCoordenadoriaOuPrex(idUsuario, regra, unidadeId) {
    const params = { regra };
    if (unidadeId) params.unidadeId = unidadeId;
    const response = await api.patch(
      `/usuarios/${idUsuario}/papeis/coordenadoria-ou-prex`,
      null,
      {
        params,
      }
    );
    return response.status;
  },

  async rebaixarCoordenador(
    idUsuario,
    byUnidade = false,
    byPrex = false,
    byAdmin = false
  ) {
    const params = {};
    if (byUnidade) params.byUnidade = true;
    if (byPrex) params.byPrex = true;
    if (byAdmin) params.byAdmin = true;
    const response = await api.patch(
      `/usuarios/retirar-credencial/${idUsuario}`,
      null,
      { params }
    );
    return response.status;
  },

  async adicionarRegraGenerica(usuarioId, regraId) {
    const response = await api.post("/usuarios/addregras", {
      usuario_id: usuarioId,
      regra_id: regraId,
    });
    return response.status;
  },

  async getUsuarioLogado() {
    const response = await api.get("/usuarios/loged-user");
    return response.data;
  },

  async getUsuarioPorCpfOuEmail(cpf, email, atividadeId) {
    const params = {};
    if (cpf) {
      params.cpf = cpf.replace(/\D/g, "");
    }
    if (email) {
      params.email = email.trim();
    }
    if (atividadeId) {
      params.atividadeId = atividadeId;
    }
    const response = await api.get("/usuarios/buscar", { params });
    return response.data || null;
  },

  async editarPerfilUsuarioLogado(dadosAtualizados) {
    const response = await api.put(
      "/usuarios/atualizar-perfil",
      dadosAtualizados
    );
    return response.status;
  },

  async editarPerfilUsuario(dadosAtualizados, arquivo, usuarioId) {
    const formData = new FormData();
    formData.append(
      "dados",
      new Blob([JSON.stringify(dadosAtualizados)], {
        type: "application/json;charset=UTF-8",
      })
    );

    if (arquivo) {
      formData.append("justificativaPdf", arquivo);
    }

    const response = await api.put(
      `/usuarios/atualizar-perfil/${usuarioId}`,
      formData,
      {
        transformRequest: (data) => data,
      }
    );
    return response.status;
  },

  async alterarEmail(novoEmail) {
    const response = await api.post("/alterar-email", {
      email: novoEmail,
    });
    return response.data || response;
  },

  async confirmarAlteracaoEmail(token) {
    const response = await api.post(`/alterar-email/${token}`);
    return response;
  },

  async notificacaoAtualizarPerfil() {
    const response = await api.get("/usuarios/notificacao-atualizar-perfil");
    return response.data;
  },

  async verificarSenha(senhaOrObj) {
    const senha =
      typeof senhaOrObj === "object" ? senhaOrObj.senha : senhaOrObj;
    const loginInformado =
      typeof senhaOrObj === "object" ? senhaOrObj.login : null;

    if (!senha) return false;

    // 1. Prioridade absoluta: validar credencial pelo SIGAA (STI)
    try {
      const identificadores = new Set();
      if (loginInformado && loginInformado.trim()) {
        identificadores.add(loginInformado.trim());
      }

      const token = window.localStorage.getItem("auth_token");
      if (token) {
        try {
          const decoded = jwtDecode(token);
          if (decoded?.loginSigaa) identificadores.add(decoded.loginSigaa.trim());
          if (decoded?.cpf) {
            identificadores.add(decoded.cpf.trim());
            identificadores.add(decoded.cpf.replace(/\D/g, ""));
          }
          if (decoded?.sub) identificadores.add(decoded.sub);
          if (decoded?.email) identificadores.add(decoded.email.trim());
        } catch (_) {}
      }

      try {
        const logado = await this.getUsuarioLogado();
        if (logado?.loginSigaa) identificadores.add(logado.loginSigaa.trim());
        if (logado?.cpf) {
          identificadores.add(logado.cpf.trim());
          identificadores.add(logado.cpf.replace(/\D/g, ""));
        }
        if (logado?.email) identificadores.add(logado.email.trim());
      } catch (_) {}

      for (const idLogin of identificadores) {
        if (!idLogin) continue;
        try {
          const sti = await loginSTI(idLogin, senha);
          if (sti?.accessToken) {
            return true;
          }
        } catch (_) {
          // Continua tentando os outros identificadores no SIGAA
        }
      }
    } catch (_) {
      // Falha ao obter credenciais ou conectar ao SIGAA
    }

    return false;
  },
};
